import React, { useContext, useState } from "react";
import {
  Modal,
  Input,
  Form,
  Select,
  Button,
  Card,
  Tabs,
  Menu,

  message
} from "antd";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";


const { Option } = Select;
const { TabPane } = Tabs;

const PLANT_STATUS_OPTIONS = [
  { value: "K", label: "Cancelled" },
  { value: "C", label: "Closed" },
  { value: "E", label: "Engineered" },
  { value: "M", label: "Mothballed" },
  { value: "H", label: "On Hold" },
  { value: "O", label: "Operational" },
  { value: "P", label: "Planned" },
  { value: "R", label: "Removed" },
  { value: "S", label: "Shuttered" },
  { value: "UC", label: "Under Construction" },
];

const PLANT_SECTOR_OPTIONS = [
  "Ag Chemicals",
  "Ag Products",
  "Automotive",
  "Baked Goods",
  "Beverages",
  "Biocrude",
  "Biodiesel/Renewable Diesel",
  "Biogas",
  "Brick & Ceramics",
  "Bulk Metals & Minerals Terminals",
  "Cement Plants",
  "Chemicals Storage",
  "Chlor-Alkali",
  "Cogeneration/CHP (Combined Heat and Power)",
  "Converted Paper Products",
  "Cosmetics, Perfumes & Toiletries-Mfg",
  "Crude Oil Production",
  "Crude Oil Refiners",
  "Crude Oil Storage",
  "Crude Pipelines",
  "Dairy",
  "Data Centers",
  "Desalination",
  "Distribution & Warehousing",
  "Distribution/Warehouse/Life Science Packaging",
  "Education/Hospital/Prison/Military/Government Infrastructure",
  "Ethanol",
  "Fabricated Metal Products",
  "Fibers",
  "Final Formulation (Oral, Solid, Parenteral, Topical, etc.)",
  "Fish & Seafood",
  "Foundries & Forge Shops",
  "Fuel Pellet",
  "Gas Processing",
  "Gas-to-Liquids (GTL)",
  "Glass Plants",
  "Heavy Manufacturing",
  "Housing, Building Products & Furniture",
  "In Vitro & In Vivo Diagnostics Mfg",
  "Industrial Gases",
  "Industrial Inorganic Chemicals (Specialty Chemicals)",
  "Ingredients (APIs, Bulk, Excipients, etc.)",
  "Laboratories",
  "Liquefied Natural Gas (LNG) Storage",
  "LNG Production",
  "Lube Oil Processors",
  "Meat & Poultry",
  "Medical Devices/Equipment/Instruments",
  "Metal Rolling, Processing, Finishing & Fabrication",
  "Micro Grid",
  "Mines",
  "Natural Gas Liquids (NGL) Storage",
  "Natural Gas Liquids Pipelines",
  "Natural Gas Pipelines",
  "Natural Gas Production",
  "Natural Gas Storage",
  "Natural Hydrogen Production",
  "Oil Sands Production",
  "Other",
  "Other Mineral Processing",
  "Other Pipelines",
  "Packaged & Prepared Foods",
  "Paper",
  "Petrochemicals",
  "Pigments",
  "Plastic & Rubber Products",
  "Plastics/Rubbers",
  "Power Generation",
  "Printing & Publishing",
  "Pulp",
  "Refined Products Pipelines",
  "Refined Products Storage",
  "Semiconductors & Computers",
  "Smelters",
  "Steel Mills",
  "Sugar",
  "Surfactants",
  "Syngas",
  "Textiles",
  "Transmission & Distribution",
  "Transportation Systems",
  "Warehousing & Distribution Centers",
  "Wood",

  // Add more as needed
];

const RefineSearch = ({ plantCoordinates = [], projectCoordinates = [] }) => {
  const {
    isRefineSearchModalVisible,
    setRefineSearchModalVisible,
    refineSearchActive,
    setRefineSearchActive,
    setRefineSearchPlantFiltersData,
    setRefineSearchEPAFiltersData,
    setRegisterid,
    setIsFacilitiesEmpty,
    setRefineSearchProjectFiltersData,
    setActiveRefineSearchType,
    setMarkerLoc,
    setGroupName,
    setProjectId,
    setActiveMarkers

  } = useContext(RegisterIdContext);


  const [selectedKey, setSelectedKey] = useState("Plant Search");

  const [formData, setFormData] = useState({
    plantStatusDesc: null,
    plantParentName: "",
    plantName: "",
    plantSectorDesc: null,
    actualCapacityMin: "",
    startupDateMin: null,
    startupDateMax: null,
    existingSqFtMin: "",
    employeeCountMin: "",
    physicalAddressCity: "",
    physicalAddressStateName: "",
    operationsLaborPreference: null,
  });

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 14 },
  };

  // ✅ Validation function to check atlest one field need to be there

  const isFormValid = (formData) => {
    return Object.values(formData).some((val) => {
      if (typeof val === "string") {
        return val.trim() !== "";
      }
      return val !== null && val !== undefined;
    });
  };
  const handleSearch = () => {
    if (!isFormValid(formData)) {
      message.error("Please select at least one field before plant searching.");
      return;
    }
    setRefineSearchPlantFiltersData(formData);
    setRefineSearchModalVisible(false);
    setRefineSearchActive(true);
    setActiveRefineSearchType("plant")
    setRegisterid([]);
    setIsFacilitiesEmpty(false)
    setMarkerLoc(null)
    setGroupName(null)
    // setActiveMarkers(projectCoordinates || [])

  };

  const handleChange = (key) => setSelectedKey(key);

  const updateFormData = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    // setRegisterid([]);
    // setIsFacilitiesEmpty(false)
  };

  const resetForm = () => {
    if (!isFormValid(formData)) {
      message.error("Please select at least one field before reseting plant.");
      return;
    }
    const resetPlantForm = {
      plantStatusDesc: null,
      plantParentName: "",
      plantName: "",
      plantSectorDesc: null,
      actualCapacityMin: "",
      startupDateMin: null,
      startupDateMax: null,
      existingSqFtMin: "",
      employeeCountMin: "",
      physicalAddressCity: "",
      physicalAddressStateName: "",
      operationsLaborPreference: null,
    }
    setFormData(resetPlantForm);
    setRefineSearchPlantFiltersData(resetPlantForm);
    setRegisterid([]);
    setIsFacilitiesEmpty(false)
    setMarkerLoc(null)
    setGroupName(null)
  };

  /** EPA Refine Search Handlers and Form */
  const [EPAformData, setEPAformData] = useState({
    sdwa_major_viol: null,        // SDWA Major Violation
    cwa_major_viol: null,
    rcra_major_viol: null,
    permit_comp_status: null,     // Non Compliance Flag
    min_avg_flow: "",             // Actual Average Flow(MGD)(Min.)
    min_dmr: "",                  // DMR Discharge(Min)
    min_design_flow: "",          // Design Flow(MGD)
    major_minor_status: null,     // Major Facility (Y/N)
    facility_type: null,          // Facility Type (POTW/NON-POTW/FEDERAL)
  });

  const handleEPARefinesearch = () => {
    setRefineSearchEPAFiltersData(EPAformData);
    setRefineSearchModalVisible(false);
    setRefineSearchActive(false)
    setActiveRefineSearchType(null)
  }
  const resetEPAForm = () => {
    const resetData = {
      sdwa_major_viol: null,        // SDWA Major Violation
      cwa_major_viol: null,
      rcra_major_viol: null,
      permit_comp_status: null,     // Non Compliance Flag
      min_avg_flow: "",             // Actual Average Flow(MGD)(Min.)
      min_dmr: "",                  // DMR Discharge(Min)
      min_design_flow: "",          // Design Flow(MGD)
      major_minor_status: null,     // Major Facility (Y/N)
      facility_type: null,          // Facility Type (POTW/NON-POTW/FEDERAL)
    }
    setEPAformData(resetData);
    setRefineSearchEPAFiltersData(resetData);
  }


  //Project Summary api integrated

  const handleProjectSearch = () => {
    if (!isFormValid(projectFormData)) {
      message.error("Please select at least one field before project searching.");
      return;
    }
    setRefineSearchProjectFiltersData(projectFormData);
    setRefineSearchModalVisible(false);
    setRefineSearchActive(true);
    setActiveRefineSearchType("project");
    setRegisterid([]);
    setIsFacilitiesEmpty(false)
    setMarkerLoc(null)
    setGroupName(null)
    setProjectId(null)
    //setActiveMarkers(plantCoordinates || [])
  };



  const [projectFormData, setProjectFormData] = useState({
    projectName: "",
    projectStatusDesc: null,
    plantName: "",
    plantParentName: "",
    physicalAddressStateName: "",
    physicalAddressCity: "",
    industryCodeDesc: null,
    plantSectorDesc: null,
    scope: "",
    tivMin: "",
    projectTypeDesc: null,
    projectFuelTypeDesc: null,
    liveDateMin: "",
    releaseDateMin: "",
    plannedCapacityMin: "",
    newSqFtMin: "",
    projectProbability: null,
    constructionLaborPreference: null,
    operationsLaborPreference: null

  });


  const resetProjectForm = () => {
    if (!isFormValid(projectFormData)) {
      message.error("Please select at least one field before reseting project.");
      return;
    }
    const resetProjectForm = {
      projectName: "",
      projectStatusDesc: null,
      plantName: "",
      plantParentName: "",
      physicalAddressStateName: "",
      physicalAddressCity: "",
      industryCodeDesc: null,
      plantSectorDesc: null,
      scope: "",
      tivMin: "",
      projectTypeDesc: null,
      projectFuelTypeDesc: null,
      liveDateMin: "",
      releaseDateMin: "",
      plannedCapacityMin: "",
      newSqFtMin: "",
      projectProbability: null,
      constructionLaborPreference: null,
      operationsLaborPreference: null
    }
    setProjectFormData(resetProjectForm);
    setRefineSearchProjectFiltersData(resetProjectForm);
    setRegisterid([]);
    setIsFacilitiesEmpty(false)
    setMarkerLoc(null)
    setGroupName(null)
    setProjectId(null)
  };

  const PROJECT_TYPE = [
    "Automation",
    "Brownfield",
    "Closure",
    "Conversion",
    "Debottleneck",
    "Efficiency Program",
    "Electricity Distribution",
    "Electricity Transmission",
    "Environmental Compliance (Process Equipment Compliance)",
    "Environmental Mandate (Product Compliance Mandate)",
    "Equipment Addition",
    "Grassroot",
    "Life Extension",
    "Modernization",
    "Optimization",
    "Pipeline Addition",
    "Pipeline Conversion",
    "Pipeline Reversal",
    "Plant Expansion",
    "Rebuild",
    "Refurbishment",
    "Renovation",
    "Replacement",
    "Repower",
    "Restart",
    "Retrofit",
    "Revamp",
    "Storage Addition",
    "Unit Addition",
    "Unit Expansion",
    "Upgrade",
    "Uprate",
  ]

  const PROJECT_FUEL_TYPE = [
    "Biodiesel",
    "Biomass",
    "Biomass Gasified",
    "Black Liquor",
    "Blast-Furnace Gas",
    "Breeze Coke",
    "Coal",
    "Coal Anthracite",
    "Coal Bed Methane",
    "Coal Bituminous",
    "Coal Gasified",
    "Coal Lignite",
    "Coal Subbituminous",
    "Coal Waste",
    "Coke-Oven Gas",
    "Combined Cycle Waste Heat",
    "Crude Oil",
    "Digester Gas",
    "Ethanol",
    "Fuel Gas",
    "Fuel Oil",
    "Fuel Oil No. 1 Distillate",
    "Fuel Oil No. 2 Distillate Diesel",
    "Fuel Oil No. 4 Distillate",
    "Fuel Oil No. 5 Residual",
    "Fuel Oil No. 6 Residual",
    "Geothermal",
    "Hydro",
    "Hydrogen",
    "Industrial Waste Heat",
    "Jet Fuel",
    "Kerosene",
    "Landfill Gas",
    "Liquefied Natural Gas",
    "Metallurgical (Coal) Coke",
    "Naphtha",
    "Natural Gas",
    "Natural Gas Liquids",
    "Nuclear",
    "Oxygen",
    "Petroleum Coke",
    "Petroleum Coke Gasified",
    "Phosphoric Acid",
    "Propane",
    "Pyrolysis Pitch",
    "Re-refined Motor Oil",
    "Solar",
    "Synthetic Natural Gas",
    "Tidal",
    "Tire Derived Fuel",
    "Waste (solid/sludge)",
    "Waste (solid/sludge) Gasified",
    "Wind",
    "Wood",

  ]

  const updateProjectFormData = (field, value) => {
    setProjectFormData(prev => ({
      ...prev,
      [field]: value
    }));

  };



  const renderPlantForm = () => (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 20 }}>
        <Button type="primary" danger onClick={resetForm}>Reset</Button>
        <Button type="primary" onClick={handleSearch}>Search</Button>
      </div>

      <Card>
        <div style={{ maxHeight: 430, overflowY: 'auto' }}>
          <Form {...formItemLayout} layout="horizontal">
            <Form.Item label="Plant Parent  Name">
              <Input
                placeholder="Enter Plant Parent name"
                allowClear
                value={formData.plantParentName}
                onChange={(e) => updateFormData("plantParentName", e.target.value)}
              />
            </Form.Item>

            <Form.Item label="Plant Status Desc">
              <Select
                placeholder="Select plant status"
                allowClear
                value={formData.plantStatusDesc}
                onChange={(val) => updateFormData("plantStatusDesc", val)}
              >
                {PLANT_STATUS_OPTIONS.map(opt => (
                  <Option key={opt.value} value={opt.label}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label="Plant Name">
              <Input
                placeholder="Enter Plant name"
                allowClear
                value={formData.plantName}
                onChange={(e) => updateFormData("plantName", e.target.value)}
              />
            </Form.Item>

            <Form.Item label="Plant Sector">
              <Select
                placeholder="Select sector"
                allowClear
                value={formData.plantSectorDesc}
                onChange={(val) => updateFormData("plantSectorDesc", val)}
              >
                {PLANT_SECTOR_OPTIONS.map(sector => (
                  <Option key={sector} value={sector}>
                    {sector}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Min Actual Capacity">
              <Input
                placeholder="Enter Actual Capacity"
                allowClear
                value={formData.actualCapacityMin}
                onChange={(e) => {
                  // allow only digits
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  updateFormData("actualCapacityMin", value);
                }}
              />
            </Form.Item>
            <Form.Item label="Min Startup Date">

              <DatePicker
                selected={
                  formData.startupDateMin
                    ? dayjs(formData.startupDateMin, "YYYY-MM-DD").toDate()
                    : null
                }
                onChange={(date) => {
                  const formatted = date ? dayjs(date).format("YYYY-MM-DD") : null;
                  updateFormData("startupDateMin", formatted);
                }}
                dateFormat="yyyy-MM-dd"
                placeholderText="Select min startup date"
                isClearable
                className="ant-input ant-datepicker-input"   // 👈 styled like AntD input
                popperPlacement="bottom-start"
                showYearDropdown             // 👈 enables year dropdown
                scrollableYearDropdown       // 👈 makes year list scrollable
                yearDropdownItemNumber={50}  // 👈 number of years to show
                showMonthDropdown
              />
            </Form.Item>
            <Form.Item label="Max Startup Date">

              <DatePicker
                selected={
                  formData.startupDateMax
                    ? dayjs(formData.startupDateMax, "YYYY-MM-DD").toDate()
                    : null
                }
                onChange={(date) => {
                  const formatted = date ? dayjs(date).format("YYYY-MM-DD") : null;
                  updateFormData("startupDateMax", formatted);
                }}
                dateFormat="yyyy-MM-dd"
                placeholderText="Select max startup date"
                isClearable
                className="ant-input ant-datepicker-input"   // 👈 styled like AntD input
                popperPlacement="bottom-start"
                showYearDropdown             // 👈 enables year dropdown
                scrollableYearDropdown       // 👈 makes year list scrollable
                yearDropdownItemNumber={50}  // 👈 number of years to show
                showMonthDropdown
              />
            </Form.Item>
            <Form.Item label="Min Existing Sq.Ft">
              <Input
                placeholder="Enter Min Existing Sq.Ft"
                allowClear
                value={formData.existingSqFtMin}
                onChange={(e) => {
                  // allow only digits
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  updateFormData("existingSqFtMin", value);
                }}

              />
            </Form.Item>
            <Form.Item label="Min Employee Count">
              <Input
                placeholder="Enter Employee Count"
                allowClear
                value={formData.employeeCountMin}
                onChange={(e) => {
                  // allow only digits
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  updateFormData("employeeCountMin", value);
                }}
              />
            </Form.Item>

            <Form.Item label="City">
              <Input
                placeholder="Enter City Name"
                allowClear
                value={formData.physicalAddressCity}
                onChange={(e) => updateFormData("physicalAddressCity", e.target.value)}
              />
            </Form.Item>
            <Form.Item label="State">
              <Input
                placeholder="Enter State Name"
                allowClear
                value={formData.physicalAddressStateName}
                onChange={(e) => updateFormData("physicalAddressStateName", e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Labor Preference">
              <Select
                placeholder="Select labor preference"
                allowClear
                value={formData.operationsLaborPreference}
                onChange={(val) => updateFormData("operationsLaborPreference", val)}
              >
                <Option value={0}>Non-Union</Option>
                <Option value={1}>Union</Option>
              </Select>
            </Form.Item>

          </Form>
        </div>
      </Card>
    </>
  );

  const renderProjectForm = () => (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 20 }}>
        <Button type="primary" danger onClick={resetProjectForm}>Reset</Button>
        <Button type="primary" onClick={handleProjectSearch}>Search</Button>
      </div>

      <Card>
        <div style={{ maxHeight: 430, overflowY: 'auto' }}>
          <Form {...formItemLayout} layout="horizontal">
            <Form.Item label="Project Parent Name">
              <Input
                placeholder="Enter Project Parent Name"
                allowClear
                value={projectFormData.plantParentName}
                onChange={(e) => updateProjectFormData("plantParentName", e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Project Name">
              <Input
                placeholder="Enter Project name"
                allowClear
                value={projectFormData.projectName}
                onChange={(e) => updateProjectFormData("projectName", e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Project Status">
              <Select
                placeholder="Enter Project Status"
                allowClear
                value={projectFormData.projectStatusDesc}
                onChange={(val) => updateProjectFormData("projectStatusDesc", val)}
              >
                <Option value="Active">Active</Option>
                <Option value="Cancelled">Cancelled</Option>
                <Option value="Complete / Done">Complete / Done</Option>
                <Option value="On Hold">On Hold</Option>
                <Option value="Unconfirmed">Unconfirmed</Option>
                <Option value="Unable to Confirm">Unable to Confirm</Option>
              </Select>
            </Form.Item>


            <Form.Item label="Plant Name">
              <Input
                placeholder="Enter Plant Name"
                allowClear
                value={projectFormData.plantName}
                onChange={(e) => updateProjectFormData("plantName", e.target.value)}
              />
            </Form.Item>

            <Form.Item label="State">
              <Input
                placeholder="Enter State Name"
                allowClear
                value={projectFormData.physicalAddressStateName}
                onChange={(e) => updateProjectFormData("physicalAddressStateName", e.target.value)}
              />
            </Form.Item>
            <Form.Item label="City">
              <Input
                placeholder="Enter City Name"
                allowClear
                value={projectFormData.physicalAddressCity}
                onChange={(e) => updateProjectFormData("physicalAddressCity", e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Industry">
              <Select
                placeholder="Enter Industry Name"
                allowClear
                value={projectFormData.industryCodeDesc}
                onChange={(val) => updateProjectFormData("industryCodeDesc", val)}
              >
                <Option value="Power">Power</Option>
                <Option value="Terminals">Terminals</Option>
                <Option value="Oil & Gas Pipelines">Oil & Gas Pipelines</Option>
                <Option value="Production (Oil & Gas)">Production (Oil & Gas)</Option>
                <Option value="Alternative Fuel">Alternative Fuel</Option>
                <Option value="Petroleum Refining (HPI)">Petroleum Refining (HPI)</Option>
                <Option value="Chemical Processing (CPI)">Chemical Processing (CPI)</Option>
                <Option value="Metals & Minerals">Metals & Minerals</Option>
                <Option value="Pulp, Paper & Wood">Pulp, Paper & Wood</Option>
                <Option value="Food & Beverage">Food & Beverage</Option>
                <Option value="Industrial Manufacturing">Industrial Manufacturing</Option>
                <Option value="Pharmaceutical & Biotech">Pharmaceutical & Biotech</Option>
              </Select>
            </Form.Item>
            <Form.Item label="Plant Sector">
              <Select
                placeholder="Enter Plant Sector"
                allowClear
                value={projectFormData.plantSectorDesc}
                onChange={(val) => updateProjectFormData("plantSectorDesc", val)}
              >
                {PLANT_SECTOR_OPTIONS.map(sector => (
                  <Option key={sector} value={sector}>
                    {sector}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Scope">
              <Input
                placeholder="Enter Scope"
                allowClear
                value={projectFormData.scope}
                onChange={(e) => updateProjectFormData("scope", e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Min Tiv">
              <Input
                placeholder="Enter Min Tiv"
                allowClear
                value={projectFormData.tivMin}
                onChange={(e) => {
                  // allow only digits
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  updateProjectFormData("tivMin", value);
                }}
              />
            </Form.Item>
            <Form.Item label="Project Type">
              <Select
                placeholder="Enter Project Type"
                allowClear
                value={projectFormData.projectTypeDesc}
                onChange={(val) => updateProjectFormData("projectTypeDesc", val)}
              >
                {PROJECT_TYPE.map(type => (
                  <Option key={type} value={type}>
                    {type}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Project Fuel Type">
              <Select
                placeholder="Enter Project Fuel Type"
                allowClear
                value={projectFormData.projectFuelTypeDesc}
                onChange={(val) => updateProjectFormData("projectFuelTypeDesc", val)}
              >
                {PROJECT_FUEL_TYPE.map(fuel => (
                  <Option key={fuel} value={fuel}>
                    {fuel}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Min Live Date">
              {/* <DatePicker
                format="YYYY-MM-DD"
                value={projectFormData.liveDateMin ? dayjs(projectFormData.liveDateMin) : null}
                onChange={(date, dateString) => updateProjectFormData("liveDateMin", dateString)}
                style={{ width: "100%" }}
                placeholder="Select Min Live Date"
              /> */}
              <DatePicker
                selected={
                  projectFormData.liveDateMin
                    ? dayjs(projectFormData.liveDateMin, "YYYY-MM-DD").toDate()
                    : null
                }
                onChange={(date) => {
                  const formatted = date ? dayjs(date).format("YYYY-MM-DD") : null;
                  updateProjectFormData("liveDateMin", formatted);
                }}
                dateFormat="yyyy-MM-dd"
                placeholderText="Select Min Live Date"
                isClearable
                className="ant-input ant-datepicker-input"   // 👈 styled like AntD input
                popperPlacement="bottom-start"
                showYearDropdown             // 👈 enables year dropdown
                scrollableYearDropdown       // 👈 makes year list scrollable
                yearDropdownItemNumber={50}  // 👈 number of years to show
                showMonthDropdown
              />
            </Form.Item>
            <Form.Item label="Min Release Date">
              {/* <DatePicker
                format="YYYY-MM-DD"
                value={projectFormData.releaseDateMin ? dayjs(projectFormData.releaseDateMin) : null}
                onChange={(date, dateString) => updateProjectFormData("releaseDateMin", dateString)}
                style={{ width: "100%" }}
                placeholder="Select Min Live Date"
              /> */}
              <DatePicker
                selected={
                  projectFormData.releaseDateMin
                    ? dayjs(projectFormData.releaseDateMin, "YYYY-MM-DD").toDate()
                    : null
                }
                onChange={(date) => {
                  const formatted = date ? dayjs(date).format("YYYY-MM-DD") : null;
                  updateProjectFormData("releaseDateMin", formatted);
                }}
                dateFormat="yyyy-MM-dd"
                placeholderText="Select Min Release Date"
                isClearable
                className="ant-input ant-datepicker-input"   // 👈 styled like AntD input
                popperPlacement="bottom-start"
                showYearDropdown             // 👈 enables year dropdown
                scrollableYearDropdown       // 👈 makes year list scrollable
                yearDropdownItemNumber={50}  // 👈 number of years to show
                showMonthDropdown
              />

            </Form.Item>
            <Form.Item label="Planned Capacity">
              <Input
                placeholder="Enter Planned Capacity"
                allowClear
                value={projectFormData.plannedCapacityMin}
                onChange={(e) => {
                  // allow only digits
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  updateProjectFormData("plannedCapacityMin", value);
                }}
              />
            </Form.Item>
            <Form.Item label="Min New Sq Ft">
              <Input
                placeholder="Enter Min New Sq Ft"
                allowClear
                value={projectFormData.newSqFtMin}
                onChange={(e) => {
                  // allow only digits
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  updateProjectFormData("newSqFtMin", value);
                }}
              />
            </Form.Item>
            <Form.Item label="Project Probability">
              <Select
                placeholder="Enter Project Probability"
                allowClear
                value={projectFormData.projectProbability}
                onChange={(val) => updateProjectFormData("projectProbability", val)}
              >
                <Option value="Low">Low</Option>
                <Option value="Medium">Medium</Option>
                <Option value="High">High</Option>
                <Option value="Completed">Completed</Option>
              </Select>
            </Form.Item>

            <Form.Item label="Unionized Construction">
              <Select
                placeholder="Select Unionized Construction"
                allowClear
                value={projectFormData.constructionLaborPreference}
                onChange={(val) => updateProjectFormData("constructionLaborPreference", val)}
              >
                <Option value="1">Union</Option>
                <Option value="0">Non-Union</Option>
              </Select>
            </Form.Item>
            <Form.Item label="Unionized Operatios">
              <Select
                placeholder="Select Unionized Operations"
                allowClear
                value={projectFormData.operationsLaborPreference}
                onChange={(val) => updateProjectFormData("operationsLaborPreference", val)}
              >
                <Option value="1">Union</Option>
                <Option value="0">Non-Union</Option>
              </Select>
            </Form.Item>

          </Form>
        </div>
      </Card>
    </>
  );

  /** EPA Form */
  const renderEPARefineForm = () => (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 20,
          gap: 8
        }}
      >
        <Button type="primary" danger onClick={resetEPAForm}>Reset</Button>
        <Button type="primary" onClick={handleEPARefinesearch}>
          Search
        </Button>
      </div>

      <Card>
        <Form {...formItemLayout} layout="horizontal">
          <Form.Item label="SDWA Major Violation">
            <Select
              placeholder="Select Major Violation"
              value={EPAformData.sdwa_major_viol}
              onChange={(value) =>
                setEPAformData({ ...EPAformData, sdwa_major_viol: value })
              }
              allowClear
            >
              <Option value="Y">YES</Option>
              <Option value="N">NO</Option>
            </Select>
          </Form.Item>

          <Form.Item label="CWA Major Violation">
            <Select
              placeholder="Select Major Violation"
              value={EPAformData.cwa_major_viol}
              onChange={(value) =>
                setEPAformData({ ...EPAformData, cwa_major_viol: value })
              }
              allowClear
            >
              <Option value="Y">YES</Option>
              <Option value="N">NO</Option>
            </Select>
          </Form.Item>

          <Form.Item label="RCRA Major Violation">
            <Select
              placeholder="Select Major Violation"
              value={EPAformData.rcra_major_viol}
              onChange={(value) =>
                setEPAformData({ ...EPAformData, rcra_major_viol: value })
              }
              allowClear
            >
              <Option value="Y">YES</Option>
              <Option value="N">NO</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Non Compliance Flag">
            <Select
              placeholder="Select Non Compliance Flag"
              value={EPAformData.permit_comp_status}
              onChange={(value) =>
                setEPAformData({ ...EPAformData, permit_comp_status: value })
              }
              allowClear
            >
              <Option value="Y">YES</Option>
              <Option value="N">NO</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Actual Average Flow(MGD)(Min.)">
            <Input
              placeholder="Enter MIN Actual Average Flow"
              value={EPAformData.min_avg_flow}
              onChange={(e) => {
                // allow only digits
                const value = e.target.value.replace(/[^0-9]/g, "");
                setEPAformData({
                  ...EPAformData,
                  min_avg_flow: value,
                });
              }}
              allowClear
            />
          </Form.Item>

          <Form.Item label="DMR Discharge(Min)">
            <Input
              placeholder="Enter MIN DMR Discharge"
              value={EPAformData.min_dmr}
              onChange={(e) => {
                // allow only digits
                const value = e.target.value.replace(/[^0-9]/g, "");
                setEPAformData({
                  ...EPAformData,
                  min_dmr: value,
                });
              }}
              allowClear
            />
          </Form.Item>

          <Form.Item label="Design Flow(MGD)">
            <Input
              placeholder="Enter Min Design Flow(MGD)(Min.)"
              value={EPAformData.min_design_flow}
              onChange={(e) => {
                // allow only digits
                const value = e.target.value.replace(/[^0-9]/g, "");
                setEPAformData({
                  ...EPAformData,
                  min_design_flow: value,
                });
              }}
              allowClear
            />
          </Form.Item>

          <Form.Item label="Major Facility">
            <Select
              placeholder="Select Major Facility"
              value={EPAformData.major_minor_status}
              onChange={(value) =>
                setEPAformData({ ...EPAformData, major_minor_status: value })
              }
              allowClear
            >
              <Option value="M">YES</Option>
              <Option value="N">NO</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Facility Type">
            <Select
              placeholder="Select Facility Type"
              value={EPAformData.facility_type}
              onChange={(value) =>
                setEPAformData({ ...EPAformData, facility_type: value })
              }
              allowClear
            >
              <Option value="POTW">POTW</Option>
              <Option value="NON-POTW">NON-POTW</Option>
              <Option value="FEDERAL">FEDERAL</Option>
            </Select>
          </Form.Item>

        </Form>
      </Card>
    </>
  );


  return (
    <Modal
      title="Refine Search"
      open={isRefineSearchModalVisible}
      onCancel={() => {
        setRefineSearchModalVisible(false);
        if (refineSearchActive) {
          window.location.reload();
        }

      }}
      footer={null}
      width={1000}
      styles={{ body: { height: "680px", padding: 0 } }}
    >
      <div style={{ display: "flex", height: "100%" }}>
        {/* Sidebar */}
        <div style={{
          width: "250px",
          borderRight: "1px solid #f0f0f0",
          overflowY: "auto",
          padding: 10
        }}>
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            onClick={(e) => handleChange(e.key)}
            items={[
              { key: "Plant Search", label: "IIR Plant / Site Search" },
              { key: "Project Search", label: "IIR Project Search" },
              { key: "EPA Resources", label: "EPA Search" }
            ]}
          />
        </div>

        {/* Main Area */}
        <div style={{ flex: 1, padding: 20, overflowY: "auto" }}>

          {/* Dynamic Header */}
          <h5 style={{ marginBottom: "5px", fontWeight: 900 }}>
            {selectedKey === "Plant Search" && "IIR Plant / Site Search"}
            {selectedKey === "Project Search" && "IIR Project Search"}
            {selectedKey === "EPA Resources" && "EPA Search"}
          </h5>

          {selectedKey === "Plant Search" && renderPlantForm()}
          {selectedKey === "Project Search" && renderProjectForm()}
          {selectedKey === "EPA Resources" && renderEPARefineForm()}
        </div>
      </div>
    </Modal >
  );
};

export default RefineSearch;